/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DesignInstallationOverview
 */
export interface DesignInstallationOverview {
  /**
   *
   * @type {string}
   * @memberof DesignInstallationOverview
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof DesignInstallationOverview
   */
  designInstallationId?: string | null;
  /**
   *
   * @type {DesignInstallationOverviewInstallationFunctionEnum}
   * @memberof DesignInstallationOverview
   */
  installationFunction?: DesignInstallationOverviewInstallationFunctionEnum | null;
  /**
   * Point coordinates as string
   * @type {string}
   * @memberof DesignInstallationOverview
   */
  designInstallationPos?: string | null;
  /**
   *
   * @type {string}
   * @memberof DesignInstallationOverview
   */
  readonly nrOfLoops?: string;
  /**
   *
   * @type {string}
   * @memberof DesignInstallationOverview
   */
  readonly nrOfWells?: string;
  /**
   *
   * @type {string}
   * @memberof DesignInstallationOverview
   */
  readonly nrOfSurfaceInfiltrations?: string;
}

/**
 * @export
 */
export const DesignInstallationOverviewInstallationFunctionEnum = {
  GeslotenBodemenergiesysteem: "geslotenBodemenergiesysteem",
  OnttrekkingEnRetournering: "onttrekkingEnRetournering",
  Onttrekking: "onttrekking",
  Infiltratie: "infiltratie",
  InfiltratieEnOnttrekking: "infiltratieEnOnttrekking",
  OpenBodemenergiesysteem: "openBodemenergiesysteem",
} as const;
export type DesignInstallationOverviewInstallationFunctionEnum =
  (typeof DesignInstallationOverviewInstallationFunctionEnum)[keyof typeof DesignInstallationOverviewInstallationFunctionEnum];

/**
 * Check if a given object implements the DesignInstallationOverview interface.
 */
export function instanceOfDesignInstallationOverview(
  value: object
): value is DesignInstallationOverview {
  return true;
}

export function DesignInstallationOverviewFromJSON(json: any): DesignInstallationOverview {
  return DesignInstallationOverviewFromJSONTyped(json, false);
}

export function DesignInstallationOverviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DesignInstallationOverview {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    designInstallationId:
      json["design_installation_id"] === undefined
        ? undefined
        : json["design_installation_id"] === null
        ? null
        : json["design_installation_id"],
    installationFunction:
      json["installation_function"] === undefined
        ? undefined
        : json["installation_function"] === null
        ? null
        : json["installation_function"],
    designInstallationPos:
      json["design_installation_pos"] === undefined
        ? undefined
        : json["design_installation_pos"] === null
        ? null
        : json["design_installation_pos"],
    nrOfLoops: json["nr_of_loops"] == null ? undefined : json["nr_of_loops"],
    nrOfWells: json["nr_of_wells"] == null ? undefined : json["nr_of_wells"],
    nrOfSurfaceInfiltrations:
      json["nr_of_surface_infiltrations"] == null ? undefined : json["nr_of_surface_infiltrations"],
  };
}

export function DesignInstallationOverviewToJSON(json: any): DesignInstallationOverview {
  return DesignInstallationOverviewToJSONTyped(json, false);
}

export function DesignInstallationOverviewToJSONTyped(
  value?: Omit<
    DesignInstallationOverview,
    "uuid" | "nr_of_loops" | "nr_of_wells" | "nr_of_surface_infiltrations"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    design_installation_id: value["designInstallationId"],
    installation_function: value["installationFunction"],
    design_installation_pos: value["designInstallationPos"],
  };
}
